import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

import { useField } from '@unform/core';

type TAutoCompleteOption = {
    option: string;
}

interface IAutoCompleteIsAdminProps {
    isExternalLoading?: boolean;
}

export const AutoCompleteIsAdmin: React.FC<IAutoCompleteIsAdminProps> = ({ isExternalLoading = false }) => {

    const { fieldName, registerField, defaultValue, error, clearError } = useField('role');
    const [selectedIsAdmin, setSelectedIsAdmin] = useState<string | undefined>(defaultValue);
    const [isLoading, setIsLoading] = useState(true);
    const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
    const [busca, setBusca] = useState('');

    useEffect(() => {
        registerField({
            name: fieldName,
            getValue: () => selectedIsAdmin,
            setValue: (_, newSelectedIsAdmin) => setSelectedIsAdmin(newSelectedIsAdmin),
        });
    }, [registerField, fieldName, selectedIsAdmin]);

    useEffect(() => {
        setIsLoading(false)
        setOpcoes([
            { option: "ADMIN" },
            { option: "REGULAR" },
            { option: "CLIENT_COMPANY" },
        ])
    }, [busca]);

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIsAdmin) return null;

        const selectedOption = opcoes.find(opcao => opcao.option === selectedIsAdmin);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIsAdmin, opcoes]);


    return (
        <Autocomplete
            openText='Abrir'
            closeText='Fechar'
            noOptionsText='Sem opções'
            loadingText='Carregando...'
            clearText='Limpar'

            disablePortal

            options={opcoes}
            getOptionLabel={(option) => option.option ?? option}
            loading={isLoading}
            disabled={isExternalLoading}
            value={autoCompleteSelectedOption}
            onInputChange={(_, newValue) => setBusca(newValue)}
            onChange={(_, newValue) => { setSelectedIsAdmin(newValue?.option); setBusca(''); clearError(); }}
            popupIcon={(isExternalLoading || isLoading) ? <CircularProgress size={28} /> : undefined}
            renderInput={(params) => (
                <TextField
                    {...params}

                    label="Administrador"
                    error={!!error}
                    helperText={error}
                />
            )}
        />
    );
};